import { Button, Modal, ModalDialog, FormControl, FormLabel, Input, Stack, IconButton } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { dateToDateString } from "../../../etc/etcfunctions";
import { Delete } from "@mui/icons-material";

const HolidayManagement: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(0);

    const [columns, setColumns] = useState<any[]>([
        { field: "targetDate", headerName: "날짜", width: 130 },
        { field: "name", headerName: "공휴일 이름", width: 200 },
        { field: "multiplier", headerName: "수당 배수", width: 100 },
        { field: "author", headerName: "등록자", width: 100 },
        { field: "createdAt", headerName: "등록일", width: 150 },
        {
            field: "delete", headerName: "삭제", width: 100, renderCell: (params: any) => {

                const id = params.row.id;

                const deleteHoliday = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        if (!window.confirm("정말로 공휴일을 삭제하시겠습니까?")) {
                            return;
                        }

                        const result: any = await postFetch("/dashboard/salary/deleteholiday", {
                            holidayId: id,
                        });

                        if (result.message === "success") {
                            props.notify("success", "공휴일이 성공적으로 삭제되었습니다.");
                            setUpdate(Math.random());
                        }

                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton
                            onClick={deleteHoliday}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false);

    // 공휴일 추가 모달의 입력값 상태 (배수는 1.5배 기본값)
    const [newHoliday, setNewHoliday] = useState({
        date: "",
        name: "",
        multiplier: "1.5",
    });

    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {

        setNewHoliday({
            date: "",
            name: "",
            multiplier: "1.5",
        });

    }, [modalOpen]);

    useEffect(() => {

        getHolidays();

    }, [update]);

    const getHolidays = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/salary/getholidays");

            if (result.message === "success") {

                const newRows: any = [];

                result.data.forEach((item: any) => {
                    const oneRow: any = {};
                    oneRow.id = item.id;
                    oneRow.targetDate = item.targetDate;
                    oneRow.name = item.name;
                    oneRow.multiplier = parseFloat(item.multiplier) + "배";
                    oneRow.author = item.authorName;
                    oneRow.createdAt = dateToDateString(new Date(item.createdAt));
                    newRows.push(oneRow);
                });

                setRows([...newRows]);
            }

            setLoading(false);

        } catch (e) {
            console.log(e);
            setLoading(false);
        }

    }

    const handleChange = (field: "date" | "name" | "multiplier", value: string) => {
        setNewHoliday((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const submitNewHoliday = async (e: React.FormEvent) => {
        e.preventDefault();

        try {

            if (!newHoliday.date || !newHoliday.name || !newHoliday.multiplier) {
                return;
            }

            if (!(parseFloat(newHoliday.multiplier) > 0)) {
                props.notify("error", "수당 배수는 0보다 커야 합니다.");
                return;
            }

            setSubmitLoading(true);

            // 날짜는 input type="date" 값("YYYY-MM-DD")을 가공 없이 그대로 전송 (타임존 이슈 방지)
            const result: any = await postFetch("/dashboard/salary/addholiday", {
                targetDate: newHoliday.date,
                name: newHoliday.name,
                multiplier: parseFloat(newHoliday.multiplier),
            });

            if (result.message === "success") {
                props.notify("success", "공휴일이 성공적으로 추가되었습니다.");
                setModalOpen(false);
                setUpdate(Math.random());
            } else {
                props.notify("error", result.message);
            }

            setSubmitLoading(false);

        } catch (e) {
            console.log(e);
            setSubmitLoading(false);
        }
    };

    return (
        <div>
            <div style={{
                marginTop: "30px",
                marginBottom: "15px",
                width: "800px",
                display: "flex",
                justifyContent: "flex-end",
            }}>
                <Button
                    variant="outlined"
                    onClick={() => setModalOpen(true)}
                >
                    공휴일 추가
                </Button>
            </div>
            <div
                style={{
                    height: "600px",
                    width: "800px",
                }}
            >
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    density="compact"
                    hideFooter={true}
                />
            </div>

            {/* 공휴일 추가 모달 */}
            <Modal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            >
                <ModalDialog>
                    <form onSubmit={submitNewHoliday}>
                        <Stack spacing={2}>
                            <div style={{ fontSize: "18px", fontWeight: 600 }}>
                                공휴일 추가하기
                            </div>

                            <FormControl>
                                <FormLabel>날짜</FormLabel>
                                <Input
                                    type="date"
                                    value={newHoliday.date}
                                    onChange={(e) =>
                                        handleChange("date", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>공휴일 이름</FormLabel>
                                <Input
                                    placeholder="공휴일 이름을 입력하세요"
                                    value={newHoliday.name}
                                    onChange={(e) =>
                                        handleChange("name", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>수당 배수 (기본 1.5배)</FormLabel>
                                <Input
                                    type="number"
                                    slotProps={{ input: { step: 0.1, min: 0.1 } }}
                                    placeholder="배수를 입력하세요"
                                    value={newHoliday.multiplier}
                                    onChange={(e) =>
                                        handleChange("multiplier", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    type="button"
                                    onClick={() => setModalOpen(false)}
                                >
                                    취소
                                </Button>
                                <Button type="submit"
                                    loading={submitLoading}
                                    disabled={
                                        submitLoading
                                        || !newHoliday.date
                                        || !newHoliday.name
                                        || !newHoliday.multiplier
                                    }
                                >
                                    전송
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
        </div>
    );
};

export default HolidayManagement;
